import { createQueryKeys } from '@lukemorales/query-key-factory';
import { getMonthlyRevenueService } from '@musinsa/services-curator';

export type RevenuePlatform = 'MUSINSA' | 'TWENTY_NINE_CM';

export const revenueFactory = createQueryKeys('revenue', {
  // 월별 수익 현황 조회 (v2, platform은 캐시 구분용)
  monthlyRevenue: (year: number, month: number, platform: RevenuePlatform) => ({
    queryKey: [{ year, month, platform }],
    queryFn: () => getMonthlyRevenueService({ year, month }),
  }),
});
